"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_froala_wysiwyg_1 = tslib_1.__importDefault(require("react-froala-wysiwyg"));
var FroalaEditorView_1 = tslib_1.__importDefault(require("react-froala-wysiwyg/FroalaEditorView"));
var remove_1 = tslib_1.__importDefault(require("lodash/fp/remove"));
require("froala-editor/css/froala_style.min.css");
require("froala-editor/css/froala_editor.pkgd.min.css");
require("froala-editor/js/plugins/align.min");
require("froala-editor/css/plugins/code_view.min.css");
require("froala-editor/js/plugins/code_beautifier.min");
require("froala-editor/js/plugins/code_view.min");
require("froala-editor/js/plugins/colors.min");
require("froala-editor/css/plugins/colors.min.css");
require("froala-editor/js/plugins/draggable.min");
require("froala-editor/css/plugins/draggable.min.css");
require("froala-editor/js/plugins/entities.min");
require("froala-editor/js/plugins/font_family.min");
require("froala-editor/js/plugins/font_size.min");
require("froala-editor/js/plugins/fullscreen.min");
require("froala-editor/css/plugins/fullscreen.min.css");
require("froala-editor/js/plugins/help.min");
require("froala-editor/css/plugins/help.min.css");
require("froala-editor/js/plugins/image.min");
require("froala-editor/css/plugins/image.min.css");
require("froala-editor/js/plugins/inline_class.min");
require("froala-editor/js/plugins/inline_style.min");
require("froala-editor/js/plugins/line_breaker.min");
require("froala-editor/css/plugins/line_breaker.min.css");
require("froala-editor/js/plugins/line_height.min");
require("froala-editor/js/plugins/link.min");
require("froala-editor/js/plugins/lists.min");
require("froala-editor/js/plugins/paragraph_format.min");
require("froala-editor/js/plugins/paragraph_style.min");
require("froala-editor/js/plugins/save.min");
require("froala-editor/js/plugins/special_characters.min");
require("froala-editor/css/plugins/special_characters.min.css");
require("froala-editor/js/third_party/spell_checker.min");
require("froala-editor/css/third_party/spell_checker.css");
require("froala-editor/js/plugins/table.min");
require("froala-editor/css/plugins/table.min.css");
require("froala-editor/js/plugins/url.min");
require("froala-editor/js/plugins/word_paste.min");
var RichTextEditor2 = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, id = _a.id, className = _a.className, isReadonly = _a.isReadonly, disabledPlugins = _a.disabledPlugins;
    var froalaConfig = react_1.useMemo(function () {
        var allPlugins = [
            'align',
            'charCounter',
            'codeBeautifier',
            'codeView',
            'colors',
            'draggable',
            'embedly',
            'emoticons',
            'entities',
            'file',
            'fontAwesome',
            'fontFamily',
            'fontSize',
            'fullscreen',
            'image',
            'imageTUI',
            'imageManager',
            'inlineStyle',
            'inlineClass',
            'lineBreaker',
            'lineHeight',
            'link',
            'lists',
            'paragraphFormat',
            'paragraphStyle',
            'quote',
            'save',
            'specialCharacters',
            'table',
            'url',
            'video',
            'wordPaste',
        ];
        var froalaConfig2 = {
            apiKey: 'FSC2H-9C2A5B5B5C1B1rXYf1VPUGRHYZNRJb2JVOOe1HAb2zA3B2A1F2F4E1C1A10B1E7==',
            key: 'FSC2H-9C2A5B5B5C1B1rXYf1VPUGRHYZNRJb2JVOOe1HAb2zA3B2A1F2F4E1C1A10B1E7==',
            pluginsEnabled: allPlugins,
            attribution: false,
            imageUploadURL: null,
            imageMaxSize: 6 * 1024 * 1024,
            imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            toolbarSticky: false,
            events: {
                'image.beforeUpload': function imageBeforeUpload(files) {
                    var _this = this;
                    if (files.length) {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            if (e === null || e.target === null)
                                return;
                            var result = e.target.result;
                            _this.image.insert(result, null, null, _this.image.get());
                        };
                        var currentFile = files[0];
                        reader.readAsDataURL(currentFile);
                    }
                    return false;
                },
            },
        };
        if (disabledPlugins) {
            var disabledPluginSet_1 = new Set(disabledPlugins);
            froalaConfig2.pluginsEnabled = remove_1.default(function (v) {
                return disabledPluginSet_1.has(v);
            })(froalaConfig2.pluginsEnabled);
        }
        return froalaConfig2;
    }, [disabledPlugins]);
    var handleChange = react_1.useCallback(function (content) {
        if (content === void 0) { content = ''; }
        onChange(content);
    }, [onChange]);
    if (isReadonly === true) {
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement(FroalaEditorView_1.default, { model: value })));
    }
    return (react_1.default.createElement("div", { id: id, className: className },
        react_1.default.createElement(react_froala_wysiwyg_1.default, { tag: "textarea", config: froalaConfig, model: value, onModelChange: handleChange })));
};
RichTextEditor2.displayName = 'FOS_RichTextEditor2';
exports.default = RichTextEditor2;
